import { render, staticRenderFns } from "./EditRdmScopeDialog.vue?vue&type=template&id=2fb304c2&scoped=true"
import script from "./EditRdmScopeDialog.vue?vue&type=script&lang=js"
export * from "./EditRdmScopeDialog.vue?vue&type=script&lang=js"
import style0 from "./EditRdmScopeDialog.vue?vue&type=style&index=0&id=2fb304c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb304c2",
  null
  
)

export default component.exports